interface Props {
  status: { text: string; kind: "info" | "error" | "success" } | null;
}

export function StatusBar({ status }: Props) {
  if (!status) return null;
  return <div className={`status status-${status.kind}`}>{status.text}</div>;
}
